export var AccountRejectedIA = function AccountRejectedIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REJECTED_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REJECTED_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REJECTED_TITLE = function ACCOUNT_REJECTED_TITLE(strictLocalize) {
  return strictLocalize({
    id: "SQcNcq",
    defaultMessage: [{
      "type": 0,
      "value": "Compte rejeté"
    }]
  });
};
var ACCOUNT_REJECTED_DESCRIPTION = function ACCOUNT_REJECTED_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x0nDyC",
    defaultMessage: [{
      "type": 0,
      "value": "Malheureusement, nous ne pouvons pas créer votre compte Faire pour l'instant. Toutes vos commandes en attente seront annulées. Si des commandes ont déjà été expédiées, vous recevrez les paiements correspondants. Nous ne sommes pas en mesure de fournir plus d'informations pour le moment. Nous vous prions de nous excuser pour le désagrément. Merci de votre compréhension."
    }]
  });
};